// Cliente HTTP para endpoints de Caixa.
// Todas as chamadas para /api/caixa* vivem aqui.
//
// WHY fetch (e nao axios): o codigo legado em Caixa.js usava fetch — manter
// para que o comportamento de tratamento de erro (chamadores recebem Response
// quando ok, lancam Error quando !ok) seja identico.

const API = process.env.REACT_APP_BACKEND_URL || "";

const authHeaders = () => {
  const tok = localStorage.getItem("token");
  return { "Content-Type": "application/json", ...(tok ? { Authorization: `Bearer ${tok}` } : {}) };
};

const get = async (path) => {
  const res = await fetch(`${API}${path}`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

const post = async (path, body) => {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    // O detalhe do servidor ("O caixa não bateu: escreva o motivo…") vira a mensagem.
    // O 409 do fechar com coisa em aberto manda um objeto {codigo, mensagem,
    // pedidos, mesas}: a mensagem vira o texto e o objeto inteiro fica em `erro.detalhe`.
    let detalhe = "";
    try { detalhe = (await res.json())?.detail; } catch (_) { /* resposta sem corpo */ }
    const texto = typeof detalhe === "string" ? detalhe : detalhe?.mensagem;
    const erro = new Error(texto || `HTTP ${res.status}`);
    erro.status = res.status;
    if (detalhe && typeof detalhe === "object") erro.detalhe = detalhe;
    throw erro;
  }
  return res.json();
};

export const caixaApi = {
  // Leituras
  // Mesma consulta do cabeçalho do painel: {status: "fechado"} ou o caixa aberto.
  status: () => get(`/api/caixa/status`),
  listarMovimentos: (caixaId) => get(`/api/caixa/${caixaId}/movimentos`),
  obterResumo: (caixaId) => get(`/api/caixa/${caixaId}/resumo`),
  listarHistorico: () => get(`/api/caixas`),
  // Aba Caixas anteriores (25/10/2026): {itens, total, total_geral, pagina, por_pagina, resumo}
  anteriores: (filtros) => get(`/api/caixas/anteriores?${new URLSearchParams(
    Object.entries(filtros).filter(([, v]) => v !== "" && v != null))}`),
  // Tudo o que trava o fechamento, na loja inteira (22/10/2026): {pedidos, mesas}
  emAberto: () => get(`/api/caixa/em-aberto`),

  // Mutacoes
  sangria: (caixaId, valor, observacao) =>
    post(`/api/caixa/${caixaId}/sangria`, { valor, observacao }),
  suprimento: (caixaId, valor, observacao) =>
    post(`/api/caixa/${caixaId}/adicionar`, { valor, observacao }),

  // Fechamento com conferência (v1.5.784): conferir compara sem fechar.
  conferir: (caixaId, contagem) => post(`/api/caixa/${caixaId}/conferir`, { contagem }),
  fechar: (caixaId, contagem, justificativa, observacao) =>
    post(`/api/caixa/${caixaId}/fechar`, { contagem, justificativa, observacao }),
};
